import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import OrderPayment from '../../../modal/Catering_Management/Manage_Payment/Payment';
import VerifyPay from '../../../modal/Catering_Management/Manage_Payment/PaymentVerification';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from "moment";
import 'react-toastify/dist/ReactToastify.css';


const ManageDelivery = () => {
    const tableRef = useRef(null);

    const [filterOpen, setFilterOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [orders, setOrders] = useState([]); 
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalEntries, setTotalEntries] = useState(0);

    const totalPages = Math.ceil(totalEntries / perPage);


    const subscriber_fil_options = [
        { value: "all", label: "All" },
        { value: "1", label: "Ragavan" },
        { value: "2", label: "Manimala" },
    ];
    const sub_plan = [
        { value: "all", label: "All" },
        { value: "1", label: "Weekly" },
        { value: "2", label: "Monthly" },
        { value: "3", label: "Yearly" },
    ];
    const products = [
        { value: "all", label: "All" },
        { value: "1", label: "Lunck Box Mini Package" },
        { value: "2", label: "Lunch Box Regular Package" },
        { value: "3", label: "Break Fast Mini Package" },
        { value: "4", label: "Break Fast Regualr Package" }
    ];
    const payment_mode = [
        { value: "all", label: "All" },
        { value: "1", label: "Cash" },
        { value: "2", label: "Bank" },
        { value: "3", label: "Gpay" },
        { value: "4", label: "paytm" },
    ];

    const payment_status = [
        { value: "all", label: "All" },
        { value: "1", label: "Pending" },
        { value: "2", label: "Paid" },
    ];

    const onClose = () => {
        setFilterOpen(false);
    };

    const handleOrderPayment = () => {
        setModalType("OrderPayment");
        setOpen(true);
    };

    const handleVerifyPayment = () => {
        setModalType("VerifyPay");
        setOpen(true);
    };

    const [selectedOption, setSelectedOption] = useState(null);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());


    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const fetchOrders = async () => {
    try {
      // Modify API URL as per your backend params for pagination & search
      const response = await axios.get(`${BaseUrl}/manage_corporate_order/delivery_list`, {
        params: {
          perPage,
          page,
          search: searchTerm,
          branch_id : branch_id,
        },
      });

      const data = response.data;
      // Assuming API returns { orders: [], total: number }
      setOrders(Array.isArray(data.orders) ? data.orders : []);
      setTotalEntries(data.total || 0);
    } catch (error) {
      setOrders([]);
      setTotalEntries(0);
      console.error('Failed to fetch orders', error);
      // Optional: toast.error('Failed to fetch orders');
    }
  };

  // Fetch orders on mount & when page/perPage/searchTerm changes
  useEffect(() => {
    fetchOrders();
  }, [perPage, page, searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(1);
  };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Corporate Delivery</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Corporate Management</li>
                    </ol>
                </div>
                {open && modalType === "OrderPayment" && (
                    <OrderPayment show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "VerifyPay" && (
                    <VerifyPay show={open} onClose={() => setOpen(false)} />
                )}
                <div className='d-flex align-items-center gap-3'>
                    {/* <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i class="fa-solid fa-circle-down fs-8"></i></span>
                            <span className=''>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#" className='px-2'>
                                <img
                                    src={csv_ico}
                                    alt="CSV"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="#" className='px-2'>
                                <img
                                    src={excel_ico}
                                    alt="Excel"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="#" className='px-2'>
                                <img
                                    src={print_ico}
                                    alt="Print"
                                    className='w-30px h-30px'
                                />
                                <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown> */}
                </div>
            </div>
             <div className="table-container">
            <div className="d-flex justify-content-between mb-3">
        <div>
          <label className="me-2">Show</label>
          <select
            className="form-select d-inline w-auto"
            style={{ fontSize: "0.85rem", height: "30px" }}
            value={perPage}
            onChange={(e) => {
              setPerPage(Number(e.target.value));
              setPage(1);
            }}
          >
            {[10, 25, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
        <div>
          <input
            type="text"
            placeholder="Search..."
            className="form-control"
            style={{ fontSize: "0.85rem", height: "40px" }}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
            </div>
            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                <thead>
                <tr className="text-start text-muted font-w600 fs-6 gs-0 th_head">
                    <th className="min-w-100px">Customer / Mob No</th>
                    <th className="min-w-100px">Order Id / Date</th>
                    <th className="min-w-100px">Delivery Address</th>
                    <th className="min-w-100px">HC / IC</th>
                    <th className="min-w-100px text-center">Delivery Status</th>
                </tr>
                </thead>
                <tbody className="text-gray-600 font-w600 fs-7">
                {orders.length === 0 ? (
                    <tr style={{ height: "60px" }}>
                    <td colSpan={5} className="text-center py-5 text-muted">
                        No orders found.
                    </td>
                    </tr>
                ) : (
                    orders.map((order) => {
                    const items = JSON.parse(order.items || "[]");
                    const orderDate = new Date(order.order_date).toLocaleDateString(
                        "en-GB"
                    );
                    return (
                        <tr key={order.id}>
                        <td>
                            <div className="d-flex flex-column gap-1">
                            <span className="text-black font-w600 fs-7">
                                {order.customer?.customer_name || "-"}
                            </span>
                            <span className="text-primary font-w600 fs-8">
                                {order.customer?.customer_number || "-"}
                            </span>
                            </div>
                        </td>
                        <td>
                            <div className="d-flex flex-column gap-1">
                            <span className="text-black font-w600 fs-7">
                                {order.catering_id}
                            </span>
                            <span className="text-primary font-w600 fs-8">
                                {orderDate}
                            </span>
                            </div>
                        </td>
                        <td>
                            <span
                            className="text-black font-w600 fs-7 text-truncate"
                            style={{ maxWidth: "150px", display: "inline-block" }}
                            title={order.delivery_address}
                            >
                            {order.delivery_address}
                            </span>
                        </td>
                        <td>
                            <div className="d-flex gap-1 align-items-center">
                            <span className="text-success rounded border border-success px-2 py-0 fs-7 font-w600">
                                {order.head_count}
                            </span>
                            <span>|</span>
                            <span className="text-danger rounded border border-danger px-2 py-0 fs-7 font-w600">
                                {items.length}
                            </span>
                            </div>
                        </td>
                         <td className="text-center">
                            {order.packing_status == 1 && (
                            <span
                                className="text-white rounded px-2 py-1 fs-7 fw-500"
                                style={{ backgroundColor: "#536ae3" }}
                            >
                                Packing
                            </span>
                            )}
                            {order.packing_status == 2 && (
                            <span
                                className="text-white rounded px-2 py-1 fs-7 fw-500"
                                style={{ backgroundColor: "#00812d" }}
                            >
                                Delivered
                            </span>
                            )}
                        </td>
                        </tr>
                    );
                    })
                )}
                </tbody>
            </table>
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="text-muted">
                {totalEntries > 0
                    ? `Showing ${(page - 1) * perPage + 1} to ${
                        (page - 1) * perPage + orders.length
                    } of ${totalEntries} entries`
                    : "Showing 0 to 0 of 0 entries"}
                </div>
                <nav>
                <ul className="pagination mb-0" style={{ fontSize: "0.75rem" }}>
                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => setPage(page - 1)}
                        disabled={page === 1}
                        style={{ padding: "0.25rem 0.5rem" }}
                    >
                        Previous
                    </button>
                    </li>
                    {[...Array(totalPages)].map((_, i) => (
                    <li
                        key={i + 1}
                        className={`page-item ${page === i + 1 ? "active" : ""}`}
                    >
                        <button
                        className="page-link"
                        onClick={() => setPage(i + 1)}
                        style={{ padding: "0.25rem 0.5rem" }}
                        >
                        {i + 1}
                        </button>
                    </li>
                    ))}
                    <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => setPage(page + 1)}
                        disabled={page === totalPages}
                        style={{ padding: "0.25rem 0.5rem" }}
                    >
                        Next
                    </button>
                    </li>
                </ul>
                </nav>
            </div>
            </div>
         
            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Payment History Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Customers</label>
                                <Select
                                    defaultValue={subscriber_fil_options[0]}
                                    onChange={setSelectedOption}
                                    options={subscriber_fil_options}
                                    placeholder="Select Customers"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Mobile No</label>
                                <input type="text" className="form-control" placeholder="Enter Mobile No" />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Payment Mode</label>
                                <Select
                                    defaultValue={payment_mode[0]}
                                    onChange={setSelectedOption}
                                    options={payment_mode}
                                    placeholder="Select Payment Mode"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Payment Status</label>
                                <Select
                                    defaultValue={payment_status[0]}
                                    onChange={setSelectedOption}
                                    options={payment_status}
                                    placeholder="Select Payment Status"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={onClose}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={onClose}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )


}
export default ManageDelivery;